import { useRouter } from "next/router";
import { Fragment }  from "react";

import { convertToSlug, getVideoCardCountPerRow } from "_common/utils";
import VideoCardList                              from "_components/organisms/videoCardList";
import useStyles                                  from "_styles/pages/newLive2/index";

import MobileComponent        from "./mobile";
import SectionHeader          from "./sectionHeader";
import { formatLiveSessions } from "./utils";

const component = ( { data = [], isMobile } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );
	const router      = useRouter ();

	const numberOfCardsPerRow =  getVideoCardCountPerRow ();

	const onClickViewMore = ( { slug, id } ) => {
		router.push ( `/live/${ id }?type=${ slug }` );
	};

	if ( isMobile ) {
		return (
			<MobileComponent
				data     = { data }
				tabsList = { data.map ( el => ( { label: el.cardName, value: el.id } ) ) }
			/>
		);

	}

	return (
		<div className = { classes.mainContainer }>
			{data.map ( ( item, idx ) => {
				if ( !item?.sessions?.length ) return <Fragment key = { idx } />;

				const slug = convertToSlug ( item.cardName );

				return (
					<div
						key       = { idx }
						className = { classes.sectionContainer }
					>
						<SectionHeader
							onClickViewMore = { () => onClickViewMore ( { androidPackageName: item.androidPackageName, slug, cardType: item.cardType, cardId: item.cardId, id: item.id } ) }
							sesstionList    = { item.sessions.slice ( 0, 3 ) }
							slug            = { slug }
							streamCount     = { item.streamCount }
							title           = { item.displayName }
							uniqueViews     = { item.uniqueViews }
						/>

						<VideoCardList
							cardType = { "stream" }
							list     = { formatLiveSessions ( item.sessions.slice ( 0, numberOfCardsPerRow ) ) }
						/>
					</div>
				);
			} )}

		</div>
	);
};

export default component;
